module.exports = __webpack_public_path__ + "img/respiratorio.8a509017.png";